import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import { TooltipsService } from '../../services/tooltips.service';
import { AnalyticsService } from '../../services/analytics.service';
import './generic-unsubscribe-form.component.scss';
var GenericUnsubscribeForm = /** @class */ (function (_super) {
    tslib_1.__extends(GenericUnsubscribeForm, _super);
    function GenericUnsubscribeForm(element) {
        return _super.call(this, element) || this;
    }
    GenericUnsubscribeForm.prototype.init = function () {
        this.containerUnsubscribe = this.element.querySelector('.generic-unsubscribe-form__container--change');
        this.containerNotValid = this.element.querySelector('.generic-unsubscribe-form__container--notvalid');
        this.containerCancelled = this.element.querySelector('.generic-unsubscribe-form__container--cancelled');
        this.containerLoader = this.element.querySelector('.generic-unsubscribe-form__container--loader');
        this.checkboxes = Array.from(this.element.querySelectorAll('.js-newsletter-modal-checkbox'));
        this.btnUnsubscribe = this.element.querySelector('.js-submit');
        this.checkboxesSelected = [];
        this.inputOtherReason = this.element.querySelector('#otherReasons');
        this.inputOtherReasonContainer = this.element.querySelector('.js-other-reasons-container');
        if (this.element.querySelector('.js-generic-unsubscribe-formid')) {
            var inputFormId = this.element.querySelector('.js-generic-unsubscribe-formid');
            if (this.element.getAttribute('data-formid')) {
                var attributeFormId = this.element.getAttribute('data-formid');
                inputFormId.value = attributeFormId;
            }
        }
        if (this.element.querySelector('.js-generic-unsubscribe-subid')) {
            var inputSubId = this.element.querySelector('.js-generic-unsubscribe-subid');
            if (this.element.getAttribute('data-subid')) {
                var attributeSubId = this.element.getAttribute('data-subid');
                inputSubId.value = attributeSubId;
            }
        }
        if (this.element.querySelector('.js-generic-unsubscribe-sitename')) {
            var inputSiteName = this.element.querySelector('.js-generic-unsubscribe-sitename');
            if (this.element.getAttribute('data-sitename')) {
                var attributeSiteName = this.element.getAttribute('data-sitename');
                inputSiteName.value = attributeSiteName;
            }
        }
        if (this.element.querySelector('.js-generic-unsubscribe-pageurl')) {
            var inputPageUrl = this.element.querySelector('.js-generic-unsubscribe-pageurl');
            if (this.element.getAttribute('data-pageurl')) {
                var attributePageURL = this.element.getAttribute('data-pageurl');
                inputPageUrl.value = attributePageURL;
            }
        }
        TooltipsService.initTooltips();
    };
    GenericUnsubscribeForm.prototype.bindEvents = function () {
        var _this = this;
        this.btnUnsubscribe.addEventListener('click', function (event) {
            var element = event.target;
            var form = element.closest('form');
            var formFields = form.querySelectorAll('input, select');
            var validation = _this.validationService.validateEnterprise(formFields);
            if (validation.valid) {
                _this.unsubscribe(form);
            }
        });
        if (this.checkboxes) {
            this.checkboxes.map(function (item) { return item.addEventListener('click', function (event) {
                var OtherSelected = false;
                _this.checkboxes.map(function (checkbox) {
                    var value = checkbox.value;
                    if (value === 'Other') {
                        if (checkbox.checked) {
                            OtherSelected = true;
                        }
                    }
                });
                if (OtherSelected) {
                    _this.inputOtherReason.removeAttribute('disabled');
                    _this.inputOtherReason.focus();
                }
                else {
                    _this.inputOtherReason.setAttribute('disabled', 'true');
                    _this.inputOtherReason.value = "";
                }
            }); });
        }
        if (this.inputOtherReasonContainer) {
            this.inputOtherReasonContainer.addEventListener('click', function (event) {
                _this.inputOtherReason.removeAttribute('disabled');
                _this.inputOtherReason.focus();
                _this.checkboxes.map(function (checkbox) {
                    var value = checkbox.value;
                    if (value === 'Other') {
                        checkbox.checked = true;
                    }
                });
            });
        }
        function stringIsValid(myString) {
            return typeof myString === 'string';
        }
    };
    GenericUnsubscribeForm.prototype.unsubscribe = function (form) {
        var _this = this;
        this.containerUnsubscribe.classList.remove('d-block');
        this.containerNotValid.classList.remove('d-block');
        this.containerCancelled.classList.remove('d-block');
        this.containerLoader.classList.add('d-block');
        var operation = "unsubscribe_topics";
        var formId = form.querySelector('input.js-generic-unsubscribe-formid').value;
        var subId = form.querySelector('input.js-generic-unsubscribe-subid').value;
        var siteName = form.querySelector('input.js-generic-unsubscribe-sitename').value;
        var pageURL = form.querySelector('input.js-generic-unsubscribe-pageurl').value;
        var email = form.querySelector('input.js-generic-unsubscribe-email').value;
        var otherReasons = '';
        if (form.querySelector('input#otherReasons')) {
            otherReasons = form.querySelector('input#otherReasons').value;
        }
        var topics = "";
        this.checkboxes.map(function (item) {
            if (item.checked) {
                _this.checkboxesSelected.push(item.value);
            }
        });
        for (var index = 0; index < this.checkboxesSelected.length; index++) {
            var topic = this.checkboxesSelected[index];
            if ((index + 1) === this.checkboxesSelected.length) {
                topics += topic;
            }
            else {
                topics += topic + "|";
            }
        }
        var postData = '';
        if (operation) {
            postData += 'operation=' + operation + '&';
        }
        if (formId) {
            postData += 'formId=' + formId + '&';
        }
        if (subId) {
            postData += 'subId=' + subId + '&';
        }
        if (siteName) {
            postData += 'site=' + siteName + '&';
        }
        if (pageURL) {
            postData += 'pageurl=' + pageURL + '&';
        }
        if (email) {
            postData += 'email=' + email + '&';
        }
        if (otherReasons) {
            postData += 'otherReasons=' + otherReasons + '&';
        }
        if (topics) {
            postData += 'topics=' + topics + '&';
        }
        var analyticsService = new AnalyticsService();
        var url = "/services/GenericUnsubscribeMailer.jsp";
        var config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        this.formsService.postForm(url, postData, config).then(function (response) {
            if (response.data === 'invalid') {
                analyticsService.dtmRecordSiteError('noerrorcode|invalid fields|' + url);
                _this.containerLoader.classList.remove('d-block');
                _this.containerNotValid.classList.add('d-block');
            }
            else {
                analyticsService.dtmFormComplete('complete', '');
                _this.containerLoader.classList.remove('d-block');
                _this.containerCancelled.classList.add('d-block');
            }
        }).catch(function (error) {
            console.log(error);
            analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
            _this.containerLoader.classList.remove('d-block');
            _this.containerUnsubscribe.classList.remove('d-block');
            _this.containerNotValid.classList.add('d-block');
        });
    };
    return GenericUnsubscribeForm;
}(Base));
export { GenericUnsubscribeForm };



//////////////////
// WEBPACK FOOTER
// ./components/generic-unsubscribe-form/generic-unsubscribe-form.component.ts
// module id = 338
// module chunks = 0